module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/bg@2x-24a5d0d66ded60fb2ba7cfebd9c0ad15.jpg";